import { BaseService } from '../../../common/http-layer/service/base.service'

export interface SupportChatWidgetEmbedResponse {
  code: string
}

/**
 * Fetches LiveChat / third-party support widget embed HTML from clientclub API.
 * Mirrors legacy `UserService.getChatWidgetConfig` (clientportal-core).
 */
export class SupportChatWidgetService extends BaseService {
  constructor() {
    super({
      baseURL: 'REST_API_URLS',
      basePath: '/clientclub',
    })
  }

  async fetchEmbedCode(locationId: string, widgetId: string): Promise<SupportChatWidgetEmbedResponse> {
    const { data } = await this.get<SupportChatWidgetEmbedResponse>(`/${locationId}/users/chat-widget`, {
      params: { widgetId, isGTM: false },
    })
    return data
  }
}
